import { Text, Title } from "@clipboard-health/ui-components";
import { Link, Stack } from "@mui/material";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";
import { generatePath } from "react-router-dom";

import { Button } from "../../components/Button";
import { CREATE_SHIFT_VERIFICATION_REQUEST_FULL_PATH } from "../path";
import { useIsSeePastShiftsEnabled } from "./useIsSeePastShiftsEnabled";

export interface UnverifiedShiftCardContentProps {
  shiftId: string;
  isTimesheetUploaded: boolean;
  onUploadTimesheetClick: (type: "upload" | "reupload") => void;
}

export function UnverifiedShiftCardContent(props: UnverifiedShiftCardContentProps) {
  const { shiftId, isTimesheetUploaded, onUploadTimesheetClick } = props;
  const { openArticle } = useZendeskArticle();
  const { paperTimesheetInstructionsSupportLink } = useSupportLinks();
  const isPastShiftsEnabled = useIsSeePastShiftsEnabled();

  if (isPastShiftsEnabled) {
    return (
      <Button
        variant="contained"
        href={generatePath(CREATE_SHIFT_VERIFICATION_REQUEST_FULL_PATH, { shiftId })}
      >
        Upload timesheet
      </Button>
    );
  }

  return (
    <Stack spacing={6}>
      <Stack spacing={3}>
        <Title component="h6">Upload a paper timesheet to get paid</Title>
        <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
          In order to get paid for this shift, you will need to submit a paper timesheet.
          <Link
            sx={{ marginLeft: 1 }}
            onClick={async () => {
              await openArticle(paperTimesheetInstructionsSupportLink);
            }}
          >
            Learn more.
          </Link>
        </Text>
      </Stack>
      <Button
        variant={isTimesheetUploaded ? "outlined" : "contained"}
        onClick={() => {
          onUploadTimesheetClick(isTimesheetUploaded ? "reupload" : "upload");
        }}
      >
        {isTimesheetUploaded ? "Reupload timesheet" : "Upload timesheet"}
      </Button>
    </Stack>
  );
}
